import React, {
  ForwardRefRenderFunction,
  forwardRef,
} from 'react';
import { FieldError } from 'react-hook-form';

import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface TextAreaProps {
  name: string;
  label?: string;
  isTextArea?: boolean;
  error?: FieldError; 
} 

const TextAreaBase: ForwardRefRenderFunction<HTMLTextAreaElement, TextAreaProps> = ({name, label, isTextArea = false, error = null, ...rest }, ref) => {
  return(
    <Container
      isTextArea={isTextArea}
      isErrored={!!error}>
      <textarea
        name={name}
        id={name}
        ref={ref}
        {...rest}
      />

      {!! error && (
        <Error title={error}>
          <FiAlertCircle color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  );
};

export const TextArea = forwardRef(TextAreaBase);
